import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import SubPageListContainer from '../../containers/widget/SubPageListContainer';

const SubPageList = () => {
  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.SUB_PAGE_LIST}>
      <SubPageListContainer />
    </PageTemplate>
  );
};

export default SubPageList;
